import React, { FC } from "react";

import { formatAmount } from "../../../utils/numbers/money";

type Props = {
  amount: number;
  currency: string;
};

export const MoneyLabel: FC<Props> = ({ amount, currency }) => {
  const strAmount = formatAmount(amount);
  const [integer, decimal] = strAmount.split(".");

  return (
    <span className="font-source-serif text-3xl font-normal text-gray-900">
      {integer}.
      <span className="text-2xl">
        {decimal} {currency}
      </span>
    </span>
  );
};
